<div class="wrapper">
  <div class="article-title">
    <img *ngIf="newsArticle.categories" src="{{ getArticleCategoryIcon(newsArticle) }}">
  
    <h1>{{ newsArticle.title }}</h1>
  
    <h2>{{ newsArticle.date }}</h2>
  </div>
  
  <div class="article-content">
    <div *ngIf="newsArticle.featuredImageUrl" class="featured-image">
      <img src="{{newsArticle.featuredImageUrl}}" alt="{{newsArticle.featuredImageAlt}}">
    </div>
  
    <div [innerHTML]="newsArticle.content" class="article-text"></div>
  </div>
  
  <div class="social-container">
    <div>
      <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">
        <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="test2">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M20.155,10.656 L18.649,10.657 C17.468,10.657 17.239,11.218 17.239,12.041 L17.239,13.857 L20.056,13.857 L19.689,16.702 L17.239,16.702 L17.239,24 L14.302,24 L14.302,16.702 L11.846,16.702 L11.846,13.857 L14.302,13.857 L14.302,11.76 C14.302,9.325 15.789,8 17.96,8 C19,8 19.894,8.077 20.155,8.112 L20.155,10.656 Z" id="Path" fill="#ADADAD"></path>
            <path d="M1,16 C1,24.2837153 7.71628475,31 16,31 C24.2843602,31 31,24.2840703 31,16 C31,7.71528475 24.2847153,1 16,1 C7.71592971,1 1,7.71563978 1,16 Z" id="Path" stroke="#ADADAD" stroke-width="2"></path> 
          </g>
        </svg>
      </a>
      <a class="twitter-share-button" href="https://twitter.com/intent/tweet?text={{getUrl()}}">
        <svg width="34" height="34" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fill-rule="evenodd">
            <path d="M23.362 13.737c.006.141.01.282.01.425 0 4.337-3.302 9.339-9.34 9.339A9.294 9.294 0 019 22.027c.257.03.518.045.783.045a6.584 6.584 0 004.077-1.405 3.285 3.285 0 01-3.067-2.279 3.312 3.312 0 001.483-.057 3.283 3.283 0 01-2.633-3.218v-.042c.442.246.949.394 1.487.411a3.282 3.282 0 01-1.016-4.383 9.32 9.32 0 006.766 3.43 3.283 3.283 0 015.593-2.994 6.568 6.568 0 002.085-.796 3.299 3.299 0 01-1.443 1.816A6.587 6.587 0 0025 12.038a6.682 6.682 0 01-1.638 1.699" fill="#ADADAD"/>
            <path d="M17 1C8.163 1 1 8.163 1 17c0 8.836 7.163 16 16 16s16-7.164 16-16c0-8.837-7.163-16-16-16" stroke="#ADADAD" stroke-width="2"/>
          </g>
        </svg>
      </a>
      <a class="linkedin-share-button" href="https://www.linkedin.com/shareArticle?mini=true&url={{getUrl()}}">
        <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fill-rule="evenodd">
            <path d="M24 23.985h-3.315v-5.188c0-1.237-.022-2.828-1.723-2.828-1.725 0-1.988 1.348-1.988 2.74v5.276h-3.312V13.317h3.178v1.459h.046c.442-.839 1.524-1.724 3.137-1.724 3.357 0 3.977 2.209 3.977 5.082v5.851zM9.924 11.86a1.923 1.923 0 11-.003-3.845 1.923 1.923 0 01.003 3.845zM11.582 23.985H8.263V13.317h3.319z" fill="#ADADAD"/>
            <path d="M16 1C7.715 1 1 7.715 1 16c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.285-6.715-15-15-15z" stroke="#ADADAD" stroke-width="2"/>
          </g>
        </svg>
      </a>
      <a href="http://pinterest.com/pin/create/button/?url={{getUrl()}}" class="pin-it-button" count-layout="horizontal">
        <svg width="34" height="34" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fill-rule="evenodd">
            <path d="M18.234 20.563c-.992 0-1.926-.536-2.245-1.146 0 0-.534 2.118-.646 2.527-.398 1.444-1.569 2.889-1.66 3.007-.063.083-.203.057-.218-.052-.025-.184-.324-2.007.028-3.493l1.182-5.008s-.293-.587-.293-1.454c0-1.362.789-2.379 1.772-2.379.836 0 1.239.628 1.239 1.38 0 .84-.535 2.097-.811 3.261-.231.975.489 1.77 1.451 1.77 1.74 0 2.913-2.236 2.913-4.886 0-2.014-1.356-3.522-3.824-3.522-2.787 0-4.525 2.079-4.525 4.402 0 .8.237 1.365.607 1.802.17.201.194.282.132.512-.045.17-.145.576-.188.738-.061.233-.249.316-.46.23-1.283-.524-1.882-1.931-1.882-3.511C10.806 12.13 13.008 9 17.374 9c3.51 0 5.819 2.538 5.819 5.265 0 3.605-2.005 6.298-4.959 6.298" fill="#ADADAD"/>
            <path d="M17 1C8.163 1 1 8.163 1 17c0 8.836 7.163 16 16 16 8.836 0 16-7.164 16-16 0-8.837-7.164-16-16-16" stroke="#ADADAD" stroke-width="2"/>
          </g>
        </svg>
      </a>
    </div>
  </div>
    
  <div class="author-container">
    <img src="{{newsArticle.authorImageUrl}}" alt="Image of {{newsArticle.author}}">
  
    <h3>{{ newsArticle.author }}</h3>

    <p>Admin</p>
  </div>
  
  <div class="article-navigation-container">
    <div *ngIf="newsArticle.previousPost.id" routerLink="/news/article/{{ newsArticle.previousPost.id }}">
      <span>
        <img src="/assets/images/arrow-news.svg" alt="Next">
        <h3>Previous</h3> 
      </span>
      <p>{{ newsArticle.previousPost.title }}</p>
    </div>

    <div *ngIf="newsArticle.nextPost.id" routerLink="/news/article/{{ newsArticle.nextPost.id }}">
      <span>
          <h3>Next</h3> 
          <img src="/assets/images/arrow-news.svg" alt="Next">
      </span>
      <p>{{ newsArticle.nextPost.title }}</p>
    </div>
  </div>
</div>

